export { default as PageNotFound } from './PageNotFound';
export { default as MenuBar } from './MenuBar';
export { default as MainGrid } from './MainGrid';
export { default as ImgBanner } from './ImgBanner';
export { default as ResponsiveGrid } from './ResponsiveGrid';
export { default as Tile } from './Tile';
export { default as TileDecription } from './TileDecription';
export { default as HostelLocation } from './HostelLocation';
export { default as ProgressiveImage } from './ProgressiveImage';
export { default as ContactUs } from './ContactUs';
export { default as Address } from './Address';
export { default as Footer } from './Footer';
export { default as VerticalMenu } from './VerticalMenu';
export { default as Logo } from './Logo';
export { default as ContactForm } from './ContactForm';
export { default as RenderField } from './RenderField';
export { default as SocialMedia } from './SocialMedia';
export { default as InfoTile } from './InfoTile';
export { default as GoogleMapsWrapper } from './GoogleMapsWrapper';
export { default as MapContainer } from './MapContainer';
export { default as Placeholder } from './Placeholder';
export { default as HostelInfo } from './HostelInfo';
export { default as ScrollToTop } from './ScrollToTop';
export { default as ButtonToTop } from './ButtonToTop';
export { default as BookingButton } from './BookingButton';
export { default as WhatsAppButton } from './WhatsAppButton';
export { default as LanguageDropDown } from './LanguageDropDown';
export { default as PhoneButton } from './PhoneButton';
export { default as OwnBookingButton } from './OwnBookingButton';
export { default as LogoMarker } from './LogoMarker';



// WEBPACK FOOTER //
// ./src/features/common/index.js